
import * as THREE from "three";
import React, { useRef } from 'react'
import {  useFrame } from '@react-three/fiber'
import {   PerspectiveCamera }  from '@react-three/drei'
import { lerp3 } from "./Utils";


import useMediaQuery from '@material-ui/core/useMediaQuery';

export default function CustomCamera(props) {

    const mobile = useMediaQuery('(max-width:960px)');
    
    // useHelper for debug
    const camera = useRef()

    var secondAnim = 0;

    useFrame(() => {
        
        var currentPos = new THREE.Vector3(0,0,0);
        var targetPos = new THREE.Vector3(0,0.5,0.2)


        var time = ( (window.scrollY - 1200) / window.innerHeight) / 5;

        var time1 = ( (window.scrollY - secondAnim) / window.innerHeight) / 5;


        if(time < 0.98)
        {
            if( window.scrollY > 1200)
            {
                secondAnim = window.scrollY;
                camera.current.position.copy(lerp3(currentPos, targetPos,time ))
            }
        }
        else
        {
            if(time1 < 0.98)
            {
                camera.current.position.copy(lerp3(targetPos, currentPos,time1 ))
            }
        }
            


        
                

        camera.current.lookAt(new THREE.Vector3(0,0,-1));

    })
    
    //Here we have the camera, the primitive line (for debug purpose), drei HTML div
    return (
        <>
            <group>
                <PerspectiveCamera 
                    makeDefault={true}
                    ref={camera} 
                    zoom={mobile ? 0.8 : 1.0}
                />
            </group>


        </>
    );

}